import { useState } from 'react';
import { TabMenu } from 'primereact/tabmenu';

interface TabBarWithIconDatamodel {
  tabs: { text: string; image: string; imageHover: string }[];
  onClick: (index: number) => void;
  disable?: boolean;
}
export const TabBarWithIcons: React.FC<TabBarWithIconDatamodel> = ({
  tabs,
  onClick,
  disable,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const itemRenderer = (item, image, imageHover, itemIndex) => (
    <a
      className="p-menuitem-link flex align-items-center gap-2"
      onClick={() => {
        setActiveIndex(itemIndex);
        onClick(itemIndex);
      }}
      onMouseEnter={() => setHoveredIndex(itemIndex)}
      onMouseLeave={() => setHoveredIndex(null)}
    >
      <img
        height={24}
        style={{ marginLeft: '4px' }}
        alt={item.name}
        src={
          hoveredIndex === itemIndex || itemIndex === activeIndex
            ? imageHover
            : image
        }
        className="hover:scale-110 transition-transform" // Just add hover effect here
      />
      <span className="font-bold">{item}</span>
    </a>
  );

  const items = tabs.map((item, index) => ({
    name: item.text,
    template: (templateItem) =>
      itemRenderer(item.text, item.image, item.imageHover, index),
  }));

  return (
    <div className="card">
      <TabMenu
        model={items}
        activeIndex={activeIndex}
        onTabChange={(e) => {
          console.log('asdasdasd');
          setActiveIndex(e.index);
          onClick(e.index);
        }}
      />
    </div>
  );
};
